/* eslint-disable */
import { IHttpClient } from '../api';
import { Employee } from "@/domain/employee";
import { AppConfig} from "@/utils/enums";

const apiUrl = `${process.env.VUE_APP_API_BASEURL}`;

export interface EmployeeResponse {
    employees: Employee[];
}

export const EmployeeApi = (http: IHttpClient) => ({
    getEmployees: () =>
        http.get<EmployeeResponse>(apiUrl + AppConfig.API_EMPLOYEES_URL).then(response => ({
            employees: response.data
        })),
    syncEmployeesWithAzureAD: () =>
        http.get<EmployeeResponse>(apiUrl + AppConfig.API_MICROSOFT_GRAPH_URL + '/syncAzureActiveDirectory').then(response => ({
            employees: response.data
        })),
    updateEmployee: (updatedEmployee: Employee) =>
        http.put<Employee>(apiUrl + AppConfig.API_EMPLOYEES_URL, updatedEmployee)
            .catch(error => {
                return error;
            })
});
